import { useLocation, Link } from "react-router-dom";
import { LoginButton } from "../components/Header/buttons/login-button";

const ErrorPage = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const error = queryParams.get("error");
    let errorDescription = queryParams.get("error_description");
    let errorTitle;

    if (errorDescription.indexOf("|~|") !== -1) {
        // decodeURIComponent
        const errorDescriptionArray = errorDescription.split("|~|");
        errorDescription = errorDescriptionArray[1];
        errorTitle = errorDescriptionArray[0];
    }


    return (
        <div className="content-width-container error-page">
            <h1>{errorTitle ? errorTitle : "Oops! Something went wrong."}</h1>
            {errorDescription ? <p>{errorDescription}</p> : <p>We encountered an issue while processing your request.</p>}
            <p>Error Code: {error || "unknown_error"}</p>
            {error === "access_denied" && (
                <div>
                    <div className="dis-inline-block spc-p-1 border-gray spc-m-b-1 bg-red-light">
                        <p>
                            If your account was recently created, please allow some time for your account to be approved.
                        </p>
                        <p className="spc-m-b-0">
                            If you feel you've received this message in error, please contact support or try logging in again.
                        </p>
                    </div>
                </div>
            )}
            <div className="button-row">
                <LoginButton className="button button-blue" text="Reattempt Login" />

                <Link to="/support" className="button button-stroke">
                    Contact Support
                </Link>

            </div>
        </div>
    );
};

export default ErrorPage;